export default __webpack_public_path__ + "static/media/prototypes-that-explain.2c28731b.svg";